import React from 'react';
import ReactDOM from 'react-dom/client';
import { env } from '~/env';
import { history } from './store';
import { routeStorage } from '../features/login/storage';
import { reportErrorToSentry } from './sentry';
import { AuthErrorPage, classifyAuthError } from '~/features/login/components/AuthErrorPage';

const saveCurrentRoute = () => {
    const initialRoute = [window.location.hash, window.location.search].join('').replace(/^#\/?/u, '');
    routeStorage.saveRoute(initialRoute);
};

const renderAuthErrorPage = (error, userManager) => {
    const container = document.getElementById('root');
    const errorType = classifyAuthError(error?.message || '');
    const onRetryLogin = () => userManager.signinRedirect({ prompt: 'login' });
    ReactDOM.createRoot(container).render(<AuthErrorPage errorType={errorType} onRetryLogin={onRetryLogin} />);
};

export const attemptInitialSignIn = async userManager => {
    const isFreshRedirect = window.location.href.includes('redirected');

    try {
        await userManager.clearStaleState();
        const user = await userManager.signinSilent();
        const initialRoute = routeStorage.getRoute();
        if (initialRoute && isFreshRedirect) {
            history.replace(`/${initialRoute}`);
        }
        routeStorage.discardRoute();
        return user;
    } catch (error) {
        console.log('sign in error ->> ', error);
        const previousUser = await userManager.getUser();
        try {
            reportErrorToSentry(error, {
            tags: { module: 'login', authFlow: isFreshRedirect ? 'post-redirect' : 'initial' },
            user: { email: previousUser?.profile?.email, id: previousUser?.profile?.sub },
        });
        } catch (e) { /* noop */ }

        if (env.runtimeConfig.login.preventRedirect) {
            // eslint-disable-next-line no-console
            console.warn('[feature/login] redirect prevented due to config. Error was', error);
            renderAuthErrorPage(error, userManager);
        } else if (isFreshRedirect) {
            routeStorage.discardRoute();
            renderAuthErrorPage(error, userManager);
        } else {
            saveCurrentRoute();
            const errorMsg = error?.message || '';
            try {
                if (errorMsg.toLowerCase().includes('aadsts16000')) {
                    await userManager.signinRedirect({ prompt: 'login' });
                } else {
                    await userManager.signinRedirect({ prompt: 'select_account' });
                }
            } catch (redirectError) {
                renderAuthErrorPage(redirectError, userManager);
            }
        }

        throw new Error('Need to sign in');
    }
};
